import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import {CacheProvider} from '@emotion/react';
import createEmotionCache from "./utils/CreateEmotionCache";
import {ThemeProvider} from '@mui/material/styles';
import adyenTheme from "./theme/adyenTheme";

const nonce = (window as any).__CSP_NONCE__;
const emotionCache = createEmotionCache(nonce);

const rootElement = document.getElementById('root');
if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <CacheProvider value={emotionCache}>
                <ThemeProvider theme={adyenTheme}>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </ThemeProvider>
            </CacheProvider>
        </React.StrictMode>
    );
}